import i18n from '@/localization/i18n'
import { IBusinessRequest, IBusinessRequestImage } from "@/models/interfaces/interfaces"

/**
 * @fileoverview
 * This file uses interface merging to avoid redefining fields in the extended interface
 * To learn more about interface merging go to:
 * {@link https://www.typescriptlang.org/docs/handbook/declaration-merging.html}
 */

const t = i18n.global.t

/**
 * Represents a BusinessRequest
 * @class
 * @example
 */
export interface BusinessRequest extends IBusinessRequest { }
export class BusinessRequest {
    /**
     * Create a BusinessRequest
     * @constructor
     * @param {IBusinessRequest} businessRequestData
     * @example
     */
    constructor(businessRequestData: IBusinessRequest) {
        Object.assign(this, businessRequestData)
    }

    /**
     * Returns the urgency of this Business Request
     * @type { String }
     */
    public get formated_urgency(): string {
        if (!this.urgency) {
            return ''
        }

        let formetedUrgency = ""

        switch (this.urgency) {
            case "g_lst_bizreq_urgency_1_high":
                formetedUrgency = t("g_lst_bizreq_urgency_1_high")
                break;
            case "g_lst_bizreq_urgency_2_std":
                formetedUrgency = t("g_lst_bizreq_urgency_2_std")
                break;
            case "g_lst_bizreq_urgency_3_flex":
                formetedUrgency = t("g_lst_bizreq_urgency_3_flex")
                break;
        }

        return formetedUrgency
    }

    /**
     * Returns the urgency of this Business Request
     * @type { String }
     */
    public get formated_status(): string {
        if (!this.status) {
            return ''
        }

        let formetedStatus = ""

        switch (this.status) {
            case "g_lst_gen_status_pending":
                formetedStatus = t("Soumise")
                break;
            case "g_lst_gen_status_active":
                formetedStatus = t("Publiée")
                break;
            case "g_lst_gen_status_inactive":
                formetedStatus = t("Désactivée")
                break;
            case "g_lst_gen_status_archived": {
                const lbr = this.leroy_business_request
                if (!lbr) break
                switch (lbr.status) {
                    case 'g_lst_leroybizreq_pending':    formetedStatus = t('Publiée');       break
                    case 'g_lst_leroybizreq_processing': formetedStatus = t('En traitement'); break
                    case 'g_lst_leroybizreq_terminated': formetedStatus = t('Désactivée');    break
                }
                break
            }
        }

        return formetedStatus
    }

    public get formated_key_words(): string[] {
        if (!this.key_words) return []

        return this.key_words.split(',') as string[]
    }
}


/**
 * @fileoverview
 * This file uses interface merging to avoid redefining fields in the extended interface
 * To learn more about interface merging go to:
 * {@link https://www.typescriptlang.org/docs/handbook/declaration-merging.html}
 */

/**
 * Represents a businessrequest image
 * @class
 * @example
 */
export interface BusinessRequestImage extends IBusinessRequestImage { }
export class BusinessRequestImage {
    /**
    * Creates a businessrequest image
    * @constructor
    * @param {IBusinessRequestImage} businessRequestImageData 
    * @example
    */
    constructor(businessRequestImageData: IBusinessRequestImage) {
        Object.assign(this, businessRequestImageData)
    }
}